import { useTranslation } from 'react-i18next'

import { CheckIcon, PencilSimpleIcon, XIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import * as Styles from './styles'

const AiFeedbackButtons = ({ onAccept, onImprove, onDiscard }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.ContainedAiButton variant="contained" size="s" onClick={onAccept}>
        <CheckIcon size={20} color={theme.colors.text.inverse} /> {t('Me gusta, utilizar mensaje')}
      </Styles.ContainedAiButton>
      <Styles.TextAiButton variant="text" size="s" onClick={onImprove}>
        <PencilSimpleIcon size={20} color={theme.colors.ai.hover} /> {t('Quiero mejorarlo')}
      </Styles.TextAiButton>
      <Styles.TextAiButton variant="text" size="s" onClick={onDiscard}>
        <XIcon size={20} color={theme.colors.ai.hover} /> {t('Descartar')}
      </Styles.TextAiButton>
    </Styles.Container>
  )
}

export default AiFeedbackButtons
